export * from './IngredientCardImage';
